import React from 'react'
import About from './About'
const Portfolio = () => {
    return (
        <div>
            <About />
        </div>
    )
}

export default Portfolio
